import EmailHasBeenSent from './EmailHasBeenSent';

export default EmailHasBeenSent;
